import type { Account } from "../types";

export type AccountDisplay = {
  label: string;
  kind: Account["kind"] | "unknown";
  assetClass: Account["assetClass"] | "unknown";
  badgeText: "LIVE" | "PAPER" | "CRYPTO PAPER" | "INVESTMENT" | "UNKNOWN";
  badgeClass: string;
};

export function accountDisplayFor(
  brokerAccountId: string | null | undefined,
  accounts: Account[],
): AccountDisplay {
  const account = accounts.find((a) => a.brokerAccountId === brokerAccountId);
  if (!account) {
    return {
      label: brokerAccountId ? `Account ${brokerAccountId.slice(0, 8)}` : "Unknown account",
      kind: "unknown",
      assetClass: "unknown",
      badgeText: "UNKNOWN",
      badgeClass: "unknown",
    };
  }
  const assetClass = account.assetClass ?? "equity";
  if (account.kind === "trading-live") {
    return {
      label: account.label,
      kind: account.kind,
      assetClass,
      badgeText: "LIVE",
      badgeClass: "live",
    };
  }
  if (account.kind === "investment") {
    return {
      label: account.label,
      kind: account.kind,
      assetClass,
      badgeText: "INVESTMENT",
      badgeClass: "investment",
    };
  }
  if (assetClass === "crypto") {
    return {
      label: account.label,
      kind: account.kind,
      assetClass,
      badgeText: "CRYPTO PAPER",
      badgeClass: "crypto-paper",
    };
  }
  return {
    label: account.label,
    kind: account.kind,
    assetClass,
    badgeText: "PAPER",
    badgeClass: "paper",
  };
}

export function AccountBadge({
  display,
}: {
  display: AccountDisplay;
}) {
  return (
    <span className={`tp-account-badge ${display.badgeClass}`}>
      {display.badgeText}
    </span>
  );
}
